module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_8011.7472f4d3.png";